import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API } from "src/app/configuration/end-points";
import { NetworkService } from "src/app/configuration/network.service";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private networkService: NetworkService,
    private http: HttpClient
  ) { }

  login(model: any) {
    return this.networkService.basicPost(model, API.LOGIN.LOGIN);
  }

  redirectLogin(model: any) {
    return this.networkService.redirectAPI(model, API.LOGIN.LOGIN);
  }

  //Method generates the public IP which is required in Login api 
  getIPAddress() {
    return this.http.get("https://api.ipify.org/?format=json").map(response => {
      return response;
    });
  }

  //Method generates the public IP which is required in Login api 
  getIPAddressAsync():Promise<any> {
    return this.http.get("https://api.ipify.org/?format=json").map(response => {
      return response;
    }).toPromise();
  }

  updatePassword(data: any) {
    try {
      const url: string = API.GET_USER.CHANGE_PASSWORD;
      return this.networkService.addModel(data, url);
    } catch (ex) {
      return null;
    }
  }

  updatePasswordForceChangePassword(data: any) {
    try {
      const url: string = API.GET_USER.CHANGE_PASSWORD;
      return this.networkService.addModelSpecial(data, url);
    } catch (ex) {
      return null;
    }
  }

  getPassworComplexityAuth() {
    let temp: any;
    return this.networkService.addModel(temp, API.GET_USER.GET_PASS_COMPLEXITY);
  }

  forcePasswordChangeGetPassworComplexityAuth() {
    let temp: any;
    return this.networkService.addModelSpecial(temp, API.GET_USER.GET_PASS_COMPLEXITY);
  }
}
